import { useQuery } from '@tanstack/react-query'
import { getFeatures } from '../services/api'
import type { FeaturesResponse } from '../services/api/features'

export const useFeaturesLoader = (enabled: boolean) => {
  return useQuery({
    queryKey: ['features'],
    queryFn: getFeatures,
    enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false
  })
}

export type { FeaturesResponse }

export default useFeaturesLoader
